import React from "react";
import GlobalButton from "../../common/GlobalButton";
import PluseIconDesign from "../../common/PluseIconDesign";

export default function CreatePDCAButton({ onClick }) {
  return <PluseIconDesign onClick={onClick}></PluseIconDesign>;
}
